// Local-time buckets: 5am–noon morning, noon–6pm afternoon, and everything
// else (including the small hours) evening.
function timeOfDayGreeting(now: Date): string {
  const hour = now.getHours()
  if (hour >= 5 && hour < 12) return "Good morning"
  if (hour >= 12 && hour < 18) return "Good afternoon"
  return "Good evening"
}

function firstNameFrom(fullName: string | null | undefined): string | null {
  const first = fullName?.trim().split(/\s+/)[0]
  return first ? first : null
}

// "Good morning, Kapil" — or just "Good morning" when there is no name.
export function greetUser(fullName: string | null | undefined, now: Date = new Date()): string {
  const greeting = timeOfDayGreeting(now)
  const firstName = firstNameFrom(fullName)
  return firstName ? `${greeting}, ${firstName}` : greeting
}
